import { useRef } from 'react'
import { useRequest } from 'ahooks'

import { Table } from '@sar/component'
import { UploadImage, UploadFile } from 'components'

import { Spin } from 'antd'
import { ProForm } from '@ant-design/pro-components'

const getData = (data, type) => (
  data
    .filter(e => e.type == type)
    .map(e => ({ url: e.url, filename: e.fileName }))
)

export default function ({ store, params, navigator }) {
  const [
      fileType
    , fileTypeEnums
  ] = React.useMemo(() => (
    [
        store.config.getConstantPairs('FileType')
      , store.config.getConstantEnums('FileType')
    ]
  ), [])

  const res = useRequest<any, any>(() => store.externals.api.get(`/orders/purchase/${params.id}`))

  const handleLoad = useRequest<any, any>(
    async () => store.externals.api.get(`/orders/purchase/${params.id}/file`).then(result => Object.assign({}, {
        [ fileType.materials ]: getData(result, fileType.materials)
      , [ fileType.purchase ]: getData(result, fileType.purchase)
      , [ fileType.present ]: getData(result, fileType.present)
      , [ fileType.splitQRCode ]: getData(result, fileType.splitQRCode)
    })),
    {
      manual: true,
    },
  )

  const handleSave = useRequest(
    async (data, type) => store.externals.api.put(`/orders/purchase/file/${params.id}?type=${type}`, data.map(elm => {
      return {
        url: elm.url,
        fileName: elm.filename,
      }
    })),

    {
      manual: true,
    },
  )

  const handleUpload = file => store.oss.client.multipartUpload(`${store.externals.nonce()}.${file.name.split('.').pop()}`, file).then(
    res => `//${store.oss.endpoint}/${res.name}`
  )

  return <div className='p-4 m-4 bg-white'>
    <Spin spinning={res.loading} tip='加载中...'>
      <table className='w-full border-collapse border border-slate-300 mb-2'>
        <tbody>
          <tr>
            <td className='border border-slate-300 text-right p-3 w-1/4 bg-gray-100'>订单编号</td>
            <td className='border border-slate-300 text-left p-3 w-1/4'>{res.data?.number}</td>
            <td className='border border-slate-300 text-right p-3 w-1/4 bg-gray-100'>客户姓名</td>
            <td className='border border-slate-300 text-left p-3 w-1/4'>{res.data?.customerName}</td>
          </tr>

          <tr>
            <td className='border border-slate-300 text-right p-3 w-1/4 bg-gray-100'>电话</td>
            <td className='border border-slate-300 text-left p-3 w-1/4'>{res.data?.customerPhone}</td>
            <td className='border border-slate-300 text-right p-3 w-1/4 bg-gray-100'>地址</td>
            <td className='border border-slate-300 text-left p-3 w-1/4'>{res.data?.customerAddress}</td>
          </tr>
        </tbody>
      </table>
    </Spin>

    <ProForm
      rowProps={{ gutter: 24 }}
      layout='vertical'
      request={() => handleLoad.runAsync()}
      onFinish={() => navigator.back()}
      readonly={!store.identity.hasPermission('/placeorder/list:upload')}
      submitter={!store.identity.hasPermission('/placeorder/list:upload') ? false : {
        searchConfig: {
          submitText: '确定',
        },
        resetButtonProps: {
          style: {
            display: 'none',
          },
        },
      }}
    >
      <UploadFile
        max={10}
        name={fileType.materials}
        label={`上传${fileTypeEnums[fileType.materials]}`}
        fieldProps={{ upload: handleUpload }}
        onSave={e => handleSave.runAsync(e, fileType.materials)}
        readonly={!store.identity.hasPermission('/placeorder/list:upload')}
      />

      <UploadFile
        max={10}
        name={fileType.purchase}
        label={`上传${fileTypeEnums[fileType.purchase]}`}
        fieldProps={{ upload: handleUpload }}
        onSave={e => handleSave.runAsync(e, fileType.purchase)}
        readonly={!store.identity.hasPermission('/placeorder/list:upload')}
      />

      <UploadFile
        max={10}
        name={fileType.present}
        label={`上传${fileTypeEnums[fileType.present]}`}
        fieldProps={{ upload: handleUpload }}
        onSave={e => handleSave.runAsync(e, fileType.present)}
        readonly={!store.identity.hasPermission('/placeorder/list:upload')}
      />

      <UploadImage
        max={1}
        help='建议尺寸800*800px'
        name={fileType.splitQRCode}
        label={`上传${fileTypeEnums[fileType.splitQRCode]}`}
        fieldProps={{ upload: handleUpload }}
        onSave={e => handleSave.runAsync(e, fileType.splitQRCode)}
        readonly={!store.identity.hasPermission('/placeorder/list:upload')}
      />
    </ProForm>
  </div>
}
